// extracted by mini-css-extract-plugin
export default {"wrapper":"Homeheadings_wrapper__E9CCD","w":"Homeheadings_w__ZgeyQ","line":"Homeheadings_line__qeBud","cont":"Homeheadings_cont__ilOkE"};